import * as React from 'react'

import { cn } from '@/lib/utils'
import styles from './button.module.css'

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "hero" | "success"
  size?: "default" | "sm" | "lg" | "icon" | "xl"
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        className={cn(
          styles.button,
          variant === 'secondary' && styles.variantSecondary,
          variant === 'outline' && styles.variantOutline,
          variant === 'ghost' && styles.variantGhost,
          variant === 'link' && styles.variantLink,
          variant === 'destructive' && styles.variantDestructive,
          variant === 'hero' && styles.variantHero,
          variant === 'success' && styles.variantSuccess,
          size === 'sm' && styles.sizeSm,
          size === 'lg' && styles.sizeLg,
          size === 'xl' && styles.sizeXl,
          size === 'icon' && styles.sizeIcon,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button }
